module.exports = __webpack_public_path__ + "img/energy_youshi.ec95efd6.png";